import { termsOfServicePageAsset } from '../assets/hosted-page-defaults/termsOfServicePageAsset';
import { privacyPolicyPageAsset } from '../assets/hosted-page-defaults/privacyPolicyPageAsset';

const hasUsableSections = data => data && Array.isArray(data.sections) && data.sections.length > 0;

/**
 * Ob die AGB-/Datenschutz-Seiten die Inhalte aus der Sharetribe Console (Asset Delivery)
 * statt der gebündelten Defaults aus dem Repo verwenden sollen.
 *
 * Steuert auch, ob die Assets überhaupt geladen werden: Ohne den Schalter
 * verwarfen die Seiten die Console-Antwort zwar, serialisierten sie aber
 * trotzdem in den Preloaded State — eine zweite, veraltete Fassung eines
 * rechtsverbindlichen Texts in jedem Seiten-Payload. Siehe `loadData` in
 * `PrivacyPolicyPage.duck.js`, `TermsOfServicePage.duck.js` und
 * `AuthenticationPage.duck.js`.
 *
 * @returns {boolean}
 */
export const hostedLegalPageAssetsEnabled = () =>
  typeof process !== 'undefined' && process.env.REACT_APP_USE_HOSTED_LEGAL_PAGE_ASSETS === 'true';

/**
 * @param {Object|null|undefined} hostedData Page-Builder-Daten aus `pageAssetsData.*.data`
 * @returns {Object} `sections` + `meta` für die AGB-Seite
 */
export const resolveTermsOfServicePageAssetData = hostedData => {
  if (hostedLegalPageAssetsEnabled() && hasUsableSections(hostedData)) {
    return hostedData;
  }
  return termsOfServicePageAsset;
};

/**
 * @param {Object|null|undefined} hostedData Page-Builder-Daten aus `pageAssetsData.*.data`
 * @returns {Object} `sections` + `meta` für die Datenschutz-Seite
 */
export const resolvePrivacyPolicyPageAssetData = hostedData => {
  if (hostedLegalPageAssetsEnabled() && hasUsableSections(hostedData)) {
    return hostedData;
  }
  return privacyPolicyPageAsset;
};
